// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css/root.css'
import './assets/css/style.css'
import './assets/css/style-c.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VCalendar from 'v-calendar';
import de from "./locales/de.json";
import en from "./locales/en.json";
import id from "./locales/id.json";
import ja from "./locales/ja.json";
import ru from "./locales/ru.json";
import zh from "./locales/zh.json";
import config from '@/config/index.js'
import { initRouteTracking } from './utils/analytics.js'


Vue.config.productionTip = false
Vue.use(BootstrapVue);

Vue.use(VCalendar, {
  firstDayOfWeek: 2,   // ...other defaults,
  formats: {
    title: 'MMM YY',
    weekdays: 'WW',
    navMonths: 'MMMM',
    input: ['DD MMM YYYY'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']

  },
  datePickerShowDayPopover:false,
  popoverExpanded:true,
  popoverDirection:"bottom"
});

import Flickity from 'vue-flickity';
Vue.component('flickity',Flickity)

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
Vue.component('v-timepicker', VueTimepicker);

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
Vue.component('pulse-loader', PulseLoader);

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
Vue.component('clip-loader', ClipLoader);

import inputCurrency from '@/components/general/inputCurrency'
Vue.component('input-currency', inputCurrency);

import inputCurrencyV2 from '@/components/general/inputCurrencyV2'
Vue.component('input-currency-v2', inputCurrencyV2);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: config.GMAPS_KEY
  }
});

import Loader from '@/components/general/Loader'
Vue.component('loader',Loader);

import ShowGmaps from '@/components/general/ShowGmaps'
Vue.component('ShowGmaps',ShowGmaps);

import WarningBox from '@/components/general/WarningBox'
Vue.component('warning-box',WarningBox);


import stateButton from '@/components/general/stateButton'
Vue.component('state-button',stateButton);

import PopupDetail from '@/components/general/PopupDetail'
Vue.component('popup-detail',PopupDetail);

import blockHeight from '@/components/general/blockHeight'
Vue.component('block',blockHeight);

import WrapperMobileView from '@/components/general/WrapperMobileView'
Vue.component('wrapper-mobile-view',WrapperMobileView)

import popupWarningAddProduct from '@/components/hotel/concierge/general/popupWarningAddProduct'
Vue.component('popupWarningAddProduct',popupWarningAddProduct);

import ErrorMessage from '@/components/hotel/concierge/general/ErrorMessage'
Vue.component('ErrorMessage',ErrorMessage);

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const messages = { de:de, en:en, id:id, ja:ja, ru:ru, zh:zh };
const locale =(store.getters.getCurrentLanguage && config.localeOptions.filter(x=>x.id==store.getters.getCurrentLanguage).length>0) ? store.getters.getCurrentLanguage : config.defaultLocale
const i18n = new VueI18n({
    locale:locale,
    fallbackLocale:'en',
    messages
})

import StarRating from 'vue-star-rating'
Vue.component('star-rating', StarRating);

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading);

import VueMeta from 'vue-meta';
Vue.use(VueMeta)

import ImgDefault from '@/components/general/DefaultImage'
Vue.component('img-default',ImgDefault);

import TopNavbar from '@/components/general/TopNavbar'
Vue.component('top-navbar',TopNavbar);

import externalPrototype from '@/utils/vuePrototype.js'
Object.assign(Vue.prototype,externalPrototype)

import Notifications from 'vue-notification'
Vue.use(Notifications)

import LazyLoad from '@/utils/directives/lazy-load';
Vue.directive('lazy', LazyLoad);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})

initRouteTracking(router);


// WEBPACK FOOTER //
// ./src/main.js